import React, { useEffect, useState } from "react";
import { batch, connect, ConnectedProps } from "react-redux";
import { RouteComponentProps } from "react-router";
import { bindActionCreators, Dispatch } from "redux";
import styled from "styled-components";
import { makeId } from "sweet-global";
import BackButton from "sweet-web/components/universal/Button/BackButton";
import NextButton from "sweet-web/components/universal/Button/NextButton";
import OutlineButton from "sweet-web/components/universal/Button/OutlineButton";
import {
  ItemTitle,
  Label,
  SectionTitle
} from "sweet-web/components/universal/Text";
import { Section, Wrapper } from "sweet-web/components/universal/View";
import { STRIPE_CLIENT_ID } from "sweet-web/keys";
import { colors } from "sweet-web/lib/styles";
import { RootState } from "sweet-web/redux";
import * as selectors from "sweet-web/redux/selectors";
import { linkStripe, UpdateVenue } from "sweet-web/redux/venue/actions";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 10px 0;
`;

type Props = RouteComponentProps & ConnectedProps<typeof connector>;

const Payment: React.FC<Props> = props => {
  const { venueId } = props.match.params as { venueId: string };
  const { venue, userEntity, loading, stripeState } = props;

  const startStripeLink = () => {
    let workingStripeVal = stripeState;
    if (!stripeState) {
      workingStripeVal = makeId();
      props.linkStripe(workingStripeVal);
    }
    workingStripeVal += `:${venueId}`;
    window.location.href = makeStripeUrl(workingStripeVal);
  };

  const makeStripeUrl = (stateVal: string): string => {
    let stripeUrl = `https://connect.stripe.com/express/oauth/authorize?`;
    stripeUrl += `redirect_uri=https://sweetbookings.co/listing/${venueId}/payment`;
    stripeUrl += `&response_type=code`;
    // stripeUrl += `&suggested_capabilities[]=transfers`;
    stripeUrl += `&client_id=${STRIPE_CLIENT_ID}`;
    stripeUrl += `&state=${stateVal}`;
    stripeUrl += `&stripe_user[business_type]=company`;
    stripeUrl += `&stripe_user[email]=${userEntity.emailAddress}`;
    stripeUrl += `&stripe_user[url]=https://sweetbookings.co/v/${venueId}`;
    stripeUrl += `&stripe_user[country]=US`;
    stripeUrl += `&stripe_user[currency]=usd`;
    stripeUrl += `&stripe_user[phone_number]=${userEntity.phoneNumber}`;
    stripeUrl += `&stripe_user[business_name]=${venue.name}`;
    stripeUrl += `&stripe_user[street_address]=${venue.location.address}`;
    stripeUrl += `&stripe_user[physical_product]=false`;
    stripeUrl += `&stripe_user[city]=${venue.location.city}`;
    stripeUrl += `&stripe_user[state]=${venue.location.state}`;
    stripeUrl += `&stripe_user[first_name]=${userEntity.firstName}`;
    stripeUrl += `&stripe_user[last_name]=${userEntity.lastName}`;

    return stripeUrl;
  };

  const next = async () => {
    props.history.push(`/listing/${venueId}/finalize`);
  };
  const back = async () => {
    props.history.push(`/listing/${venueId}/photos`);
  };

  return (
    <Wrapper>
      <Section>
        <SectionTitle style={{ marginBottom: 0 }}>
          Get Paid Through Sweet
        </SectionTitle>
        <Label>Setup your account to receive deposits and payments</Label>
        <Content>
          {!venue.stripe && !venue.stripeAuthCode && (
            <OutlineButton
              title="Link Bank Account or Debit Card"
              onClick={startStripeLink}
            />
          )}
          {venue.stripeAuthCode && !venue.paymentPreview && (
            <ItemTitle style={{ color: colors.primary }}>
              Payment linking in progress
            </ItemTitle>
          )}
          {venue.stripe && venue.paymentPreview && (
            <React.Fragment>
              <ItemTitle style={{ color: colors.primary }}>
                {venue.paymentPreview}
              </ItemTitle>
              <OutlineButton
                style={{ marginTop: 10 }}
                title="Update Payment Information"
                color="gray"
              />
            </React.Fragment>
          )}
        </Content>
      </Section>
      <BackButton onClick={back} />
      <NextButton primary={true} loading={loading} onClick={next} />
    </Wrapper>
  );
};

const mapState = (state: RootState, ownProps: RouteComponentProps) => {
  const { venueId } = ownProps.match.params as { venueId: string };

  return {
    venue: selectors.getVenue(venueId)(state),
    loading: selectors.isUpdatingVenue(state),
    stripeState: selectors.linkStripe(state),
    userEntity: selectors.user(state)
  };
};
const mapDispatch = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      linkStripe
    },
    dispatch
  );
const connector = connect(mapState, mapDispatch);

export default connector(Payment);
